import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { UiProfileService } from '../../services/ui-profile.service';


@Component({
  selector: 'SideBar-content',
  templateUrl: './side-bar-content.component.html',
  styleUrls: ['./side-bar-content.component.scss']
})
export class SideBarContentComponent implements OnChanges {
  @Input() selectedItem!: string;
  @Input() items: any;
  @Input() collapsed!: boolean;
  @Input() isRight!: boolean;
  @Input() selectedMenuItem!: string[];
  @Input() ChildReports:any;
  @Output() backToNav = new EventEmitter<any>();
  @Output() navigateToScreen = new EventEmitter<string>();
  expandedPanels: { [key: string]: number } = {};
  childExpandedPanels: { [key: string]: number } = {};
  activeButton: any;
  constructor(private uiProfileService: UiProfileService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['selectedMenuItem']?.currentValue) {
      this.applySelection()
    }
  }

  private applySelection() {
    if (this.selectedMenuItem?.length === 0) {
      this.resetExpansation();
    } else {
      this.applyExpansation()
    }
  }

  private applyExpansation() {
    let lastItem: any;
    let lastIndex: any;
    this.selectedMenuItem.forEach((item, index) => {
      let itemsUsed = (index === 0 ? [...this.items] : [...lastItem.children]);
        lastIndex = itemsUsed.findIndex((i: any) => i.text === this.selectedMenuItem[index]);
        lastItem = {...itemsUsed[lastIndex]};

        if (index === 1) this.expandedPanels[this.selectedItem] = lastIndex;
        else if (index === 2) this.childExpandedPanels[this.selectedItem] = lastIndex;

        if (index === (this.selectedMenuItem.length - 1)) {
          this.setActiveButton(item);
          setTimeout(() =>{
            document.getElementById('btn-' + item)?.focus();
          }, 0)
        }
    });
  }

  private resetExpansation() {
    this.expandedPanels[this.selectedItem] = -1;
    this.childExpandedPanels[this.selectedItem] = -1;
  }

  returnToNav(): void {
    this.backToNav.emit();
    this.resetExpansation();
  }
  navigate(path: string): void{
    this.navigateToScreen.emit(path);
    this.uiProfileService.emitrecentPage({PageName: this.activeButton, PageUrl: path});
   }
   setActiveButton(buttonText: string): void {
    this.activeButton = buttonText;
  }
}